import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAuthSelector } from 'js/store/hooks';

export const useGetCredentialsLoginHooks = () => {
    const afterCredentialsLoginHooks = useAuthSelector(prop('afterCredentialsLoginHooks'));

    return useCallback(() => {
        return Promise.all(afterCredentialsLoginHooks.map((fn) => new Promise(fn)));
    }, [afterCredentialsLoginHooks]);
};
